<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('eservice_conversion.title') }}
        <Bookmark service_type_code='6422' />

        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="front_loc">{{ $t('eservice_conversion.title') }} > </span>
          <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">

          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01 active">
              <h2>{{ $t('eservice_conversion.fields.step_01') }}</h2>
              <p>{{ $t('eservice_conversion.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('eservice_conversion.fields.step_02') }}</h2>
              <p>{{ $t('eservice_conversion.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('eservice_conversion.fields.step_03') }}</h2>
              <p>{{ $t('eservice_conversion.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <h2 class="m_title">{{ $t('eservice_conversion.fields.search_application')}}</h2>
            <v-flex>
              <SearchApplications
                :applicant_show_yn.sync="applicant_show_yn"
                :service_type_code="service_type_code"
                @success="fnSuccessChks"
                @change="fnChagneApp"
              />
            </v-flex>
          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                dark
                color="#a01c2a"
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                style="color: #FFF!important"
                :disabled="!nextYn"
                @click="fnGoNext()"
              >{{ $t('common.button.next') }}</v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import SearchApplications from './SearchApplications'
import Bookmark from '@/components/layout/Bookmark'

export default {
  components :{
    Bookmark,
    SearchApplications
  },
  data() {
    return {
      request_receipt_posts : [],

      nextYn: false,
      applicant_show_yn : true,
      application_no : '',

      service_type_code : '6422',
      notExistApplicationCnt: 0
    }
  },

  mounted() {
    window.scrollTo(0, 0)
  },

  methods: {
    fnSuccessChks(chked_item){
      this.notExistApplicationCnt = 0
      this.request_receipt_posts = []

      chked_item.applications.forEach(item => {
        if (item.res_code === '400') this.notExistApplicationCnt ++
        this.request_receipt_posts.push(item.application_no)
      })

      // 다음버튼 활성화
      if(chked_item.chkResult && chked_item.applications.length > 0){
        this.nextYn =  true
      }else{
        this.nextYn =  false
      }
    },


    fnChagneApp(){
      this.request_receipt_posts = []
      this.nextYn = false
    },

    fnGoNext() {
      if (this.notExistApplicationCnt > 0) {
        let option = {
          text : this.$t('common.message.delete_application_msg'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)
        return
      }

      let params = {
        application_nos : this.request_receipt_posts
      }

      requestApi({
        url: '/receivings/conversion',
        method: 'POST',
        data : params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.$router.push({path : '/eserviceconversion/step2/' + res.data.receipt_no})

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGoNext()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  }
}
</script>